export const DEBUG_CATEGORY = 'DEBUG_CATEGORY'

export default DEBUG_CATEGORY
